import AnimateOnPageLinks from 'components/AnimateOnPageLinks';
import AutoDownload from 'components/AutoDownload';
import Carousel from 'components/Carousel';
import LazyLoading from 'components/LazyLoading';
import Masonry from 'components/Masonry';
import ReplaceObfuscatedEmailAddresses
    from 'components/ReplaceObfuscatedEmailAddresses';
import VideoPlayer from 'components/VideoPlayer';

/**
 * Initialise components
 */
const Components = {

    // default components to enable
    components: [
        'AnimateOnPageLinks',
        'AutoDownload',
        'Carousel',
        'LazyLoading',
        'Masonry',
        'ReplaceObfuscatedEmailAddresses',
        'VideoPlayer',
    ],

    // map component name to import
    mapping: {
        'AnimateOnPageLinks': AnimateOnPageLinks,
        'AutoDownload': AutoDownload,
        'Carousel': Carousel,
        'LazyLoading': LazyLoading,
        'Masonry': Masonry,
        'ReplaceObfuscatedEmailAddresses': ReplaceObfuscatedEmailAddresses,
        'VideoPlayer': VideoPlayer,
    },

    /**
     * Initialise components
     *
     * @param {string[]} _components  Override components to enable (use [] to
     *   disable all components)
     */
    init(_components = false)
    {

        let vm = this;

        // allow overriding of enabled components
        const components = _components === false ? vm.components : _components;

        components.forEach(component => {

            if (typeof vm.mapping[component] == 'undefined') {
                if (scriptVars.isDebug) {
                    console.warn(
                        `Component init - '${component}' does not exist`);
                }
                return;
            }
            vm.mapping[component].init();

        });

    },

};

export default Components;